class NjesiRaportuese {
  constructor(id, emer) {
    this.id = id;
    this.emer = emer;
  }
}

export default NjesiRaportuese;
